import React from "react";
import Slider from "react-slick";

import ava01 from "../images/t2.jpg";
import ava02 from "../images/p1.jpg";
import ava03 from "../images/t.jpg";
import ava04 from "../images/t1.jpg";
import Container from "./Container";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 1000,
    lazyLoad: "ondemand",
    slidesToShow: 3, // Number of slides visible
    slidesToScroll: 1,
    centerMode: true, // Enables space between slides
    centerPadding: "15px", // Adds a gap of 15px on both sides of the slide
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "10px", // Reduce gap on smaller screens
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "5px", // Further reduce gap for mobile screens
        },
      },
    ],
  };
  
  

  return (
<Container class1="home-wrapper-1">
    <div className="testimonial-wrapper py-5">
        <div className="testimonial-overlay"></div>
        <div className="testimonial-el">
  <div className="popular-header">
  <span className="section-tag">Client Success Stories</span>
  <h2>What Our Clients Say About Us</h2>
     </div>

  <Slider {...settings}>
    <div className="testimonial py-4 px-3">
      <p className="section__description">
        "Qentrain Solutions Ltd helped us streamline our food production process, ensuring compliance with industry standards. Their expertise in product development and business modelling was invaluable to our growth!"
      </p>
      <div className=" mt-3 d-flex align-items-center gap-4">
        <img src={ava01} alt="James Mwangi" className="w-25 h-25 rounded-2" />
        <div>
          <h6 className="mb-0 mt-3">George Maloba</h6>
          <p className="section__description">Food Processing Entrepreneur</p>
        </div>
      </div>
    </div>

    <div className="testimonial py-4 px-3">
      <p className="section__description">
        "Thanks to Qentrain’s financial management consultancy, we optimized our accounting systems and improved our financial tracking. Their team’s insights were a game changer for our agribusiness."
      </p>
      <div className="mt-3 d-flex align-items-center gap-4">
        <img src={ava02} alt="Aisha Mohammed" className="w-25 h-25 rounded-2" />
        <div>
          <h6 className="mb-0 mt-3">Winnie Kanji</h6>
          <p className="section__description">Business Owner</p>
        </div>
      </div>
    </div>

    <div className="testimonial py-4 px-3">
      <p className="section__description">
        "The ISO training we received from Qentrain Solutions Ltd was well-structured and practical. Our internal audit team is now fully equipped to maintain ISO compliance thanks to their excellent training sessions."
      </p>
      <div className="mt-3 d-flex align-items-center gap-4">
        <img src={ava03} alt="Samuel Kariuki" className="w-25 h-25 rounded-2" />
        <div>
          <h6 className="mb-0 mt-3">Dennis Waithaka</h6>
          <p className="section__description">Quality Assurance Manager</p>
        </div>
      </div>
    </div>

    <div className="testimonial py-4 px-3">
      <p className="section__description">
        "The team at Qentrain provided outstanding training in business modelling and planning. Their expertise and hands-on approach helped our startup develop a solid foundation for sustainable growth."
      </p>
      <div className="mt-3 d-flex align-items-center gap-4">
        <img src={ava04} alt="Emily Njoroge" className="w-25 h-25 rounded-2" />
        <div>
          <h6 className="mb-0 mt-3">Emily Njoroge</h6>
          <p className="section__description">Startup Founder</p>
        </div>
      </div>
    </div>
  </Slider>
</div>

    </div>
</Container>

  );
};

export default Testimonial;


